import React, {
  PropTypes,
} from 'react';
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc';

export const withSorter = () => (WrappedComponent) => {
  const SortableItem = SortableElement(({ order, ...rest }) => {
    return (
      <WrappedComponent index={order} {...rest} />
    )
  })
  const SortableList = SortableContainer(
    ({ collection, style, ...rest }) => {
      return (
        <div style={style}>
          {collection.map((item, i) => {
            return (
              <SortableItem
                key={i}
                index={i}
                order={i}
                item={item}
                {...rest}
              />
            )
          })}
        </div>
      )
    });

  return (props) => {
    const onSortEnd = ({ oldIndex, newIndex }) => {
      const { onUpdate, collection, onRawChange = () => {} } = props;
      onRawChange(arrayMove(collection, oldIndex, newIndex))
      return onUpdate(arrayMove(collection, oldIndex, newIndex))
    };
    return (
      <SortableList
        {...props}
        pressDelay={150}
        onSortEnd={onSortEnd}
      />
    )
  }
};



// WEBPACK FOOTER //
// ./src/hocs/bases/withSorter.js